class DataCollectionViews {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/data-collection-views`;

  }

  async setupDataCollectionView(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getDataCollectionViewForEditor(collectionViewId) {

    const path = `${this.basePath}/:collectionViewId`;

    return this.apiClient.get(path, { collectionViewId }, {});

  }

  async getDataCollectionViewRecordsForEditor(collectionViewId) {

    const path = `${this.basePath}/:collectionViewId/records/editor`;

    return this.apiClient.get(path, { collectionViewId }, {});

  }

  async updateDataCollectionViewFilterById(collectionViewId, data) {

    const path = `${this.basePath}/:collectionViewId/filter`;

    return this.apiClient.put(path, { collectionViewId }, {}, data);

  }

  async updateDataCollectionViewColumnsById(collectionViewId, data) {

    const path = `${this.basePath}/:collectionViewId/columns`;

    return this.apiClient.put(path, { collectionViewId }, {}, data);

  }

  async updateDataCollectionViewPageSizeById(collectionViewId, data) {

    const path = `${this.basePath}/:collectionViewId/page-size`;

    return this.apiClient.put(path, { collectionViewId }, {}, data);

  }

  async updateDataCollectionViewConjunctionWordById(collectionViewId, data) {

    const path = `${this.basePath}/:collectionViewId/conjunction-word`;

    return this.apiClient.put(path, { collectionViewId }, {}, data);

  }

}

export default DataCollectionViews;